import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
        key: "/localmoving",
        icon: <FiCast />,
        title: 'Local Moving',
        description: 'Are you planning a local move within Greater Vancouver? You can trust Moonline to make your move smooth and effortless.'
    },
    {
        key: "/longdistance", 
        icon: <FiMonitor />,
        title: 'Long Distance Moving',
        description: 'The moving process can be daunting and overwhelming for you either you are moving to your first house'
    },
    {
        key: "/commercial",
        icon: <FiLayers />,
        title: 'Commercial Services',
        description: 'When you have a business to run where you have to please your clients and manage your employees.'
    },
    {
        key: "/piano", 
        icon: <FiMonitor />,
        title: 'Piano Moving',
        description: 'When you are planning a move then one thing that can trouble you is your piano. '
    },
    {
        key: "/heavymoving", 
        icon: <FiMonitor />,
        title: 'Large and Heavy Item Moving',
        description: 'Moving your household materials from one location to another location is such a stress. Moonline is there to help you.'
    },
    {
        key: "/packing", 
        icon: <FiMonitor />,
        title: 'Packing / Unpacking',
        description: 'Whether you are reducing the size of your company, want temporary storage during your house search'
    },
    {
        key: "/storage", 
        icon: <FiMonitor />,
        title: 'Storage',
        description: 'Whether you are reducing the size of your company, want temporary storage during your house search'
    },
    {
        key: "/furnituremoving",
        icon: <FiUsers />,
        title: 'Furniture Moving',
        description: 'Moonline is one of the top furniture moving companies in Canada. '
    }
    
    // {
    //     key: "/furnitureassembly",
    //     icon: <FiUsers />,
    //     title: 'Furniture Assembly',
    //     description: 'We must move at least once in lifetime. Packing your bags is such a notoriously stressful process.'
    // },
    
    
    
    
]


class AboutTwo extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a href={val.key}>
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default AboutTwo;